import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * UX REFINEMENT HOTFIX — legacy alias.
 * `/ajustes/tema` se sentía técnico. La experiencia ahora vive en
 * `/mi-identidad`. Mantenemos la ruta para no romper bookmarks.
 */
export const Route = createFileRoute("/ajustes/tema")({
  beforeLoad: () => {
    throw redirect({ to: "/mi-identidad", replace: true });
  },
  component: () => null,
});